import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [{
    path: '',
    name: 'home',
    component: require('../views/Home.vue').default,
    meta: {
        title: 'Trang chủ',
        auth: true
    }
},
{
    path: '/login',
    name: 'login',
    component: require('../views/Login.vue').default,
    meta: {
        title: 'Đăng nhập',
        guest: true
    }
},
{
    path: '/temporaryorder',
    name: 'temporaryorder',
    component: require('../views/TemporaryOrder.vue').default,
    meta: {
        title: 'Tạo đơn tạm',
        auth: true
    }
},
{
    path: '/account',
    name: 'account',
    component: require('../views/Account.vue').default,
    meta: {
        title: 'thông tin acc',
        auth: true
    }
},
{
    path: '/orderhistory',
    name: 'orderhistory',
    component: require('../views/OrderHistory.vue').default,
    meta: {
        title: 'Lịch sử đơn hàng',
        auth: true
    }
},
{
    path: '/admin',
    name: 'admin',
    component: require('../views/AdminDashboard.vue').default,
    meta: {
        title: 'Bảng quản trị',
        auth: true
    }
},
{
    path: '/returnhistory',
    name: 'returnhistory',
    component: require('../views/ReturnOrderHistory.vue').default,
    meta: {
        title: 'Lịch sử trả hàng',
        auth: true
    }
},
{
    path: '/productlist',
    name: 'productlist',
    component: require('../views/ProductList.vue').default,
    meta: {
        title: 'Danh sách sản phẩm',
        auth: true
    }
},
{
    path: '/importhistory',
    name: 'importhistory',
    component: require('../views/ImportHistory.vue').default,
    meta: {
        title: 'Lịch sử nhập kho',
        auth: true
    }
},
{
    path: '/category',
    name: 'category',
    component: require('../views/Category.vue').default,
    meta: {
        title: 'Quản lý Danh mục',
        auth: true
    }
},
{
    path: '/debt',
    name: 'debt',
    component: require('../views/Debt.vue').default,
    meta: {
        title: 'Quản lý Công nợ',
        auth: true
    }
},
{
    path: '/transaction',
    name: 'transaction',
    component: require('../views/Transaction.vue').default,
    meta: {
        title: 'Quản lý Thu/Chi',
        auth: true
    }
},
{
    path: '/supplier',
    name: 'supplier',
    component: require('../views/Supplier.vue').default,
    meta: {
        title: 'Quản lý Nhà cung cấp',
        auth: true
    }
},
{
    path: '/customer',
    name: 'customer',
    component: require('../views/Customer.vue').default,
    meta: {
        title: 'Quản lý Khách hàng',
        auth: true
    }
},
{
    path: '/user',
    name: 'user',
    component: require('../views/User.vue').default,
    meta: {
        title: 'Quản lý Người dùng',
        auth: true
    }
},
{
    path: '/settings',
    name: 'settings',
    component: require('../views/Settings.vue').default,
    meta: {
        title: 'Cấu hình Hệ thống',
        auth: true
    }
},
{
    path: '/report/revenue',
    name: 'revenuereport',
    component: require('../views/RevenueReport.vue').default,
    meta: {
        title: 'Báo cáo Doanh thu',
        auth: true
    }
},
{
    path: '/notifications',
    name: 'notifications',
    component: require('../views/NotificationView.vue').default,
    meta: {
        title: 'Thông báo',
        auth: true
    }
},
{
    path: '/printed-bills',
    name: 'printedbills',
    component: require('../views/PrintedBills.vue').default,
    meta: {
        title: 'Lịch sử in Bill',
        auth: true
    }
},

    // {
    //     path: '/register',
    //     name: 'register',
    //     component: require('../views/Register.vue').default,
    //     meta: {
    //         title: 'Đăng ký',
    //         guest: true
    //     }
    // },
    // {
    //     path: '/lostpass',
    //     name: 'lostpass',
    //     component: require('../views/LostPass.vue').default,
    //     meta: {
    //         title: 'Quên mật khẩu',
    //         guest: true
    //     }
    // },

    // {
    //     path: '/list-new-task',
    //     name: 'list-new-task',
    //     component: require('../views/ListNewTask.vue').default,
    //     meta: {
    //         title: 'Công việc cần làm',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/list-contract',
    //     name: 'list-contract',
    //     component: require('../views/ListContract.vue').default,
    //     meta: {
    //         title: 'Hợp đồng của tôi',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/list-jobs-request',
    //     name: 'list-jobs-request',
    //     component: require('../views/ListJobsRequest.vue').default,
    //     meta: {
    //         title: 'Lịch sử yêu cầu',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/list-address',
    //     name: 'list-address',
    //     component: require('../views/ListAddress.vue').default,
    //     meta: {
    //         title: 'Địa chỉ thang máy',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/list-jobs-request-contract-:id-:cat_id',
    //     name: 'list-jobs-request-contract',
    //     component: require('../views/ListNewTask.vue').default,
    //     meta: {
    //         title: 'Lịch sử bảo trì',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/list-jobs-of-request-:id',
    //     name: 'list-jobs-of-request',
    //     component: require('../views/ListJobsOfRequest.vue').default,
    //     meta: {
    //         title: 'Chi tiết yêu cầu',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/list-doing-task',
    //     name: 'list-doing-task',
    //     component: require('../views/ListDoingTask.vue').default,
    //     meta: {
    //         title: 'Công việc đang làm',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/list-done-task',
    //     name: 'list-done-task',
    //     component: require('../views/ListDoneTask.vue').default,
    //     meta: {
    //         title: 'Công việc đã xong',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/task-detail-:id',
    //     name: 'task-detail',
    //     component: require('../views/TaskDetail.vue').default,
    //     meta: {
    //         title: 'Chi tiết công việc',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/tich-diem',
    //     name: 'accumulate',
    //     component: require('../views/Accumulate.vue').default,
    //     meta: {
    //         title: 'Tích điểm',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/hang-thanh-vien',
    //     name: 'rank',
    //     component: require('../views/Rank.vue').default,
    //     meta: {
    //         title: 'Hạng thành viên',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/doi-qua',
    //     name: 'gift',
    //     component: require('../views/Gift.vue').default,
    //     meta: {
    //         title: 'Đổi quà',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/doi-qua/:id(\\d+).html',
    //     name: 'gift_detail',
    //     component: require('../views/GiftDetail.vue').default,
    //     meta: {
    //         title: 'Chi tiết quà',
    //         auth: false
    //     }
    // },
    // {
    //     path: '/:type',
    //     name: 'list',
    //     component: require('../views/List.vue').default
    // },
    // {
    //     path: '/:type/gio-hang',
    //     name: 'cart',
    //     component: require('../views/Cart.vue').default
    // },
    // {
    //     path: '/:type/:cat([a-zA-Z0-9-]+)',
    //     name: 'cat',
    //     component: require('../views/Cat.vue').default
    // },
    // {
    //     path: '/:type/group/:group([a-zA-Z0-9-]+)',
    //     name: 'group',
    //     component: require('../views/Group.vue').default
    // },
    // {
    //     path: '/:type/:alias-:id(\\d+).html',
    //     name: 'detail',
    //     component: require('../views/Detail.vue').default
    // },
    // {
    //     path: '/*',
    //     name: '404',
    //     component: require('../views/404.vue').default
    // }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

// Bắt lỗi trùng lặp cho cả `push` và `replace`
const originalPush = router.push;
router.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
    });
};

const originalReplace = router.replace;
router.replace = function replace(location) {
    return originalReplace.call(this, location).catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
    });
};

const Cookie = require('vue-cookie');
const Base64 = require('base-64');

window.appType = Cookie.get('app_type');
if (!window.appType) {
    window.appType = '';
}

let query = window.location.search.replace('?', '').split('&');
for (let i = 0; i < query.length; i++) {
    let t = query[i].split('=');
    if (t[0] == 'android') {
        window.appType = 'Android';
        break;
    } else if (t[0] == 'ios') {
        window.appType = 'iOS';
        break;
    }
}

query = window.location.search.replace('?', '');
if (query != '') {
    query = query.split('&');
    for (let i in query) {
        let d = query[i].split('=');
        if (d[0] == 'android') {
            localStorage.setItem('opt_type', Base64.encode('Android'));
        } else if (d[0] == 'ios') {
            localStorage.setItem('opt_type', Base64.encode('iOS'));
        }
    }
}

Cookie.set('app_type', appType, 7);

router.beforeEach((to, from, next) => {
    let token = Cookie.get('opt_ck2884');
    let userId = null;
    let userRole = null;

    if (token) {
        try {
            const decoded = Base64.decode(token);
            userId = decoded.includes('-') ? decoded.split('-')[0] : decoded;

            const roleToken = Cookie.get('opt_role');
            if (roleToken) {
                userRole = Base64.decode(roleToken);
            }
        } catch (e) {
            userId = null;
        }
    }

    // Load settings from localStorage for permission checks
    let settings = null;
    const savedSettings = localStorage.getItem('pos_settings');
    if (savedSettings) {
        try { settings = JSON.parse(savedSettings); } catch (e) { }
    }

    // Auth check
    if (to.matched.some(record => record.meta.auth)) {
        if (!userId) {
            return next({ name: 'login' });
        }

        // Permission Check (Dynamic based on settings)
        // Admin always has bypass - robust check
        if (userRole && userRole.toString().toLowerCase().trim() === 'admin') return next();

        if (settings && settings.user && settings.user.roles && userRole) {
            const roleConfig = settings.user.roles[userRole];
            if (roleConfig && roleConfig.menus) {
                const allowedMenus = roleConfig.menus;
                // Always allow 'home', 'notifications' and 'account' regardless of saved settings for authenticated users
                if (!['home', 'account', 'notifications'].includes(to.name) && !allowedMenus.includes(to.name)) {
                    return next({ name: 'home' });
                }
            } else {
                if (!['home', 'account', 'notifications'].includes(to.name)) {
                    return next({ name: 'home' });
                }
            }
        } else {
            if (!['home', 'account', 'notifications'].includes(to.name)) {
                return next({ name: 'home' });
            }
        }

        next();
    } else if (to.matched.some(record => record.meta.guest)) {
        if (userId) {
            next({ name: 'home' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;